import React from 'react';
import ContactForm from '../ContactFrom/ContactForm'
import Img01 from '../../images/contact-left-img.jpg'



const Contactpage = () => {

    return (
        <div>

            <section className="wpo-contact-page section-padding">
                <div className="container">
                    <div className="office-info">
                        <div className="row">
                            <div className="col col-lg-4 col-md-6 col-12">
                                <div className="office-info-item">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-location-1"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Office Address</h2>
                                        <p>Yau Lee Centre, UNIT 78, 3/F,
                                            <br />45 Hoi Yuen Rd, Kwun Tong</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lg-4 col-md-6 col-12">
                                <div className="office-info-item active">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-clock"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Support Hours</h2>
                                        <p>Monday to Friday
                                            <br />9:30 AM to 6:30 PM</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lg-4 col-md-6 col-12">
                                <div className="office-info-item">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-email"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Email Us</h2>
                                        <p>support@ferrygoldshipping.com
                                            <br />info@ferrygoldshipping.com</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="contact-wrap">
                        <div className="row">
                            <div className="col-lg-6 col-12">
                                <div className="contact-left">
                                    <h2>Get in touch with our logistics team</h2>
                                    <p>
                                        Reach out for shipment tracking, booking support, and cargo movement planning.
                                        Our team will get back to you with the right next steps for your request.
                                    </p>
                                    <img className="image" src={Img01} alt="Ferry Gold Shipping contact support" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="contact-right">
                                    <div className="title">
                                        <h2>Send us your request</h2>
                                        <p>Share your details and we will contact you shortly. Required fields are marked *</p>
                                    </div>
                                    <ContactForm />
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </section >

        </div >
    )


}

export default Contactpage;
